import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static identifier = "terminal"
    static targets = ["panel", "toggleButton"]

    toggle() {
        const isHidden = this.panelTarget.classList.toggle("hidden")
        document.cookie = `terminalPanelHidden=${isHidden}; path=/; max-age=31536000`
        this.toggleButtonTarget.textContent = isHidden ? "[+]" : "[–]"
    }
}
